import { render, staticRenderFns } from "./LeftLowerBarDeletePoint.vue?vue&type=template&id=65ac0830&scoped=true&"
import script from "./LeftLowerBarDeletePoint.vue?vue&type=script&lang=js&"
export * from "./LeftLowerBarDeletePoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ac0830",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65ac0830')) {
      api.createRecord('65ac0830', component.options)
    } else {
      api.reload('65ac0830', component.options)
    }
    module.hot.accept("./LeftLowerBarDeletePoint.vue?vue&type=template&id=65ac0830&scoped=true&", function () {
      api.rerender('65ac0830', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/LowerBar/LowerBarLeftSide/LeftLowerBarDeletePoint.vue"
export default component.exports